import { render, staticRenderFns } from "./special_price_detail.vue?vue&type=template&id=39ba6076&scoped=true"
import script from "./special_price_detail.vue?vue&type=script&lang=js"
export * from "./special_price_detail.vue?vue&type=script&lang=js"
import style0 from "./special_price_detail.vue?vue&type=style&index=0&id=39ba6076&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba6076",
  null
  
)

export default component.exports